import Navbar from "@components/navbar";
import Footer from "@components/footer";
import React from "react";
import CookieConsent from "react-cookie-consent";

import { navbarHeightTopMargin } from "./layout.module.css";

interface HeaderFooterProps {
  children: React.ReactNode;
}

const HeaderFooter: React.FC<HeaderFooterProps> = ({ children }) => {
  const cookieHeaderStyle = {
    fontSize: "24px",
    marginBottom: "20px"
  };
  return (
    <>
      <Navbar />
      <main className={`px-6 ${navbarHeightTopMargin}`}>{children}</main>
      <Footer className="mt-24 md:mt-52" />
      <CookieConsent
        location="bottom"
        buttonText="Accept"
        declineButtonText="Decline"
        enableDeclineButton
        cookieName="gatsby-gdpr-google-analytics"
        style={{ padding: "10px", alignItems: "end" }}
        buttonWrapperClasses="btn-group"
      >
        <h2 style={cookieHeaderStyle}>We use cookies</h2>
        <p>
          Railsfactory website uses cookies to enhance your browsing experience.
        </p>
      </CookieConsent>
    </>
  );
};

export default HeaderFooter;
